import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Check, ArrowRight, Lock } from 'lucide-react';
import axios from 'axios';
import { motion } from 'framer-motion';

const QuickUpgrade = ({ currentPlan, user }) => {
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();

  const plans = {
    numerology: { name: 'Numerology Master', price: 149, color: 'from-cyan-500 to-blue-600' },
    vastu: { name: 'Vastu Pro', price: 149, color: 'from-emerald-500 to-green-600' },
    astrology: { name: 'Astrology Elite', price: 149, color: 'from-purple-500 to-pink-600' },
    weekly_report: { name: 'Live Weekly Oracle', price: 149, color: 'from-orange-500 to-red-600' },
    bundle: { name: 'Ultimate Bundle', price: 349, color: 'from-yellow-400 to-red-600', savings: 247 }
  };

  const plan = plans[currentPlan];

  const handleQuickUpgrade = async () => {
    if (!user) {
      navigate('/auth');
      return;
    }

    setProcessing(true);

    try {
      // For logged-in users, use their existing details
      const response = await axios.post('/api/payments/guest-checkout', {
        plan_id: currentPlan,
        plan_name: plan.name,
        amount: plan.price * 100,
        user_email: user.email,
        user_phone: user.phone || '9999999999',
        user_name: user.full_name || 'Valued Customer'
      });

      if (response.data.success && response.data.redirect_url) {
        localStorage.setItem('pending_order_id', response.data.merchant_order_id);
        localStorage.setItem('upgrading_user', 'true');
        window.location.href = response.data.redirect_url;
      } else {
        alert(response.data.message || 'Payment failed');
        setProcessing(false);
      }
    } catch (error) {
      alert(error.response?.data?.detail || 'Error initiating payment');
      setProcessing(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="card"
      style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center', padding: '3rem', border: '2px solid #F59E0B' }}
    >
      <div style={{ 
        width: '80px', 
        height: '80px', 
        margin: '0 auto 1.5rem',
        background: `linear-gradient(135deg, ${plan.color.split(' ')[1]}, ${plan.color.split(' ')[3]})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Lock size={40} color="white" />
      </div>

      <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#F9FAFB' }}>
        {plan.name} Locked
      </h2>

      <p style={{ color: '#9CA3AF', fontSize: '1.125rem', marginBottom: '2rem' }}>
        Unlock this module to access all {currentPlan} features
      </p>

      {/* Price */}
      <div style={{ 
        background: 'rgba(0,0,0,0.3)', 
        borderRadius: '16px', 
        padding: '1.5rem',
        marginBottom: '2rem'
      }}>
        <div style={{ fontSize: '0.875rem', color: '#9CA3AF', marginBottom: '0.5rem' }}>
          One-time upgrade
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '3rem', fontWeight: 'bold', color: '#F9FAFB' }}>₹{plan.price}</span>
          <span style={{ fontSize: '1.25rem', color: '#9CA3AF' }}>/month</span>
        </div>
        {plan.savings && (
          <div style={{ color: '#F59E0B', fontWeight: 600, marginTop: '0.5rem' }}>
            Save ₹{plan.savings}/month with bundle!
          </div>
        )}
      </div>

      {/* Quick Upgrade Button */}
      <button
        onClick={handleQuickUpgrade}
        disabled={processing}
        className={`btn btn-primary`}
        style={{ 
          fontSize: '1.25rem', 
          padding: '1rem 2rem',
          width: '100%',
          marginBottom: '1rem',
          opacity: processing ? 0.5 : 1
        }}
      >
        {processing ? 'Processing...' : `Unlock for ₹${plan.price}/month`}
      </button>

      <p style={{ fontSize: '0.875rem', color: '#9CA3AF' }}>
        <Check style={{ display: 'inline', width: '16px', height: '16px' }} /> No form filling required - we have your details
      </p>

      {/* Bundle Upsell if not bundle */}
      {currentPlan !== 'bundle' && (
        <div style={{ 
          marginTop: '2rem', 
          padding: '1.5rem',
          background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.1), rgba(251, 146, 60, 0.1))',
          border: '2px solid rgba(251, 191, 36, 0.3)',
          borderRadius: '16px'
        }}>
          <Crown size={32} color="#FBBF24" style={{ margin: '0 auto 0.75rem' }} />
          <div style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#FBBF24', marginBottom: '0.5rem' }}>
            Or Get ALL 4 Modules
          </div>
          <div style={{ color: '#9CA3AF', fontSize: '0.875rem' }}>
            Ultimate Bundle - ₹349/month (Save ₹247)
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default QuickUpgrade;
